import { ArrowRight, BarChart3, Gift, Link2, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { Brand, ButtonLink } from "../../design-system";

export function HomePage() {
  return (
    <main className="landing">
      <header className="landing__header">
        <Brand />
        <nav>
          <Link to="/parceiro/entrar">Entrar</Link>
          <ButtonLink size="sm" to="/parceiro/cadastrar">
            Quero ser parceiro
          </ButtonLink>
        </nav>
      </header>
      <section className="landing__hero">
        <div>
          <span className="eyebrow">Programa de indicações</span>
          <h1>
            Boas conexões geram <em>novas histórias.</em>
          </h1>
          <p>
            Indique pessoas para a clínica, acompanhe cada etapa e receba pontos
            por resultados reais.
          </p>
          <div className="landing__actions">
            <ButtonLink to="/parceiro/cadastrar">
              Começar agora <ArrowRight size={18} />
            </ButtonLink>
            <ButtonLink variant="secondary" to="/parceiro/entrar">
              Já sou parceiro
            </ButtonLink>
          </div>
          <span className="landing__trust">
            <ShieldCheck size={18} /> Seus dados protegidos em conformidade com
            a LGPD
          </span>
        </div>
        <div
          className="hero-visual"
          aria-label="Resumo do funcionamento do programa"
        >
          <div className="hero-visual__glow" />
          <article>
            <span>
              <Link2 />
            </span>
            <div>
              <small>Seu link exclusivo</small>
              <strong>conecta.com/r/seu-nome</strong>
            </div>
          </article>
          <article>
            <span>
              <BarChart3 />
            </span>
            <div>
              <small>Indicações acompanhadas</small>
              <strong>Jornada transparente</strong>
            </div>
          </article>
          <article>
            <span>
              <Gift />
            </span>
            <div>
              <small>Pontos acumulados</small>
              <strong>Benefícios especiais</strong>
            </div>
          </article>
        </div>
      </section>
      <section className="landing__steps">
        <span className="eyebrow">Simples do início ao fim</span>
        <h2>Compartilhe. Acompanhe. Conquiste.</h2>
        <div>
          <article>
            <b>01</b>
            <Link2 />
            <h3>Compartilhe</h3>
            <p>Use seu link ou QR Code exclusivo.</p>
          </article>
          <article>
            <b>02</b>
            <BarChart3 />
            <h3>Acompanhe</h3>
            <p>Veja a evolução das suas indicações.</p>
          </article>
          <article>
            <b>03</b>
            <Gift />
            <h3>Resgate</h3>
            <p>Troque seus pontos por recompensas.</p>
          </article>
        </div>
      </section>
    </main>
  );
}
